<template>


    <div class="d-none d-md-flex" >
        <button v-on:click="move(  ItemId, 'down', $event)" data-direction="down" class="bg-info mx-1 move-button down btn float-right"><i class="fas fa-arrow-down"></i></button>
         <button v-on:click="move(  ItemId, 'up', $event)"  data-direction="up" class="bg-info mx-1 move-button up btn float-right"><i  class="fas fa-arrow-up"></i></button>
    </div>
</template>

<script>
	export default {
		props: [
		'LoopIndex', 'ItemId', 'direction', 'ParentId'
		],

		methods: {
            move(ItemID, direction) {
                let formData = new FormData();
                formData.append('ItemId', ItemID);


                axios.post( '/manage/menu/move/'+direction+'/'+ItemID + '/' + this.ParentId, formData )
                    .then(function(data) {
                        console.log(data);
                    }.bind(this)).catch(function(data) {

                    console.log('error', data);
                    alert('f');
                });


            }
        }



	}
</script>


// WEBPACK FOOTER //
// resources/js/components/MenuButtons.vue